import { Injectable, ElementRef, Renderer } from '@angular/core';

import { ApiService, CacheService, LogService, SeoService, AppContext } from './../shared';
import { Contacts } from './../shared/models/contacts';
import { Carrier, Vessel } from './../shared/models';
import { VesselResults } from '../shared/models/results';

@Injectable()
export class CarriersService {
  queryString: string = '';

  public loaderOff = false;
  public noCarrier = false;
  public noVessels = false;
  public localContactsLoader = false;
  el: HTMLElement;
  content: HTMLElement;
  container: HTMLElement;

  constructor(private api: ApiService, private cache: CacheService, private logger: LogService,
    private seo: SeoService, public app: AppContext, el: ElementRef, private renderer: Renderer) {
  }

  getVessels(params): Promise<VesselResults> {
    this.logger.log('carriers.service', 'getVessels', params);
    // let cache = this.cache.get('vessels' + this.queryString);
    let promise = this.api.getApiClient().then(client => this.callGetVessels(client, params));
    // let server = Observable.fromPromise(promise);
    // this.vessels = server;
    // this.vessels = Observable.concat(cache, server);
    // this.cache.updateCache('vessels' + this.queryString, this.vessels);

    return promise;
  }

  callGetVessels(apigClient: any, query): Promise<VesselResults> {
    this.logger.log('carriers.service', 'callGetVessels', query);
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: query
      };
      try {
        apigClient.vesselsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('carriers.service', 'vessels result', result);
            if (result.data === null) {
              this.resizeSidebar();
              this.loaderOff = true;
              this.noVessels = true;
            } else if (result.data.items.length === 0 || result.data.summary.count === 0) {
              this.resizeSidebar();
              this.loaderOff = true;
              this.noVessels = true;
            } else {
              this.resizeSidebar();
              this.loaderOff = true;
            }

            let formatted = new VesselResults(result, this.app.accountType);

            resolve(formatted);
          }).catch((err) => {
            this.resizeSidebar();
            this.loaderOff = true;
            this.noVessels = true;
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        reject(null);
      }
    });
  }

  getCarrier(carrierId: number): Promise<any> {
    this.logger.log('carriers.service', 'getCarriers', carrierId);
    // let cache = this.cache.get('carriers' + carrierId);
    let promise = this.api.getApiClient().then(client => this.callGetCarrier(client, carrierId));
    // let server = Observable.fromPromise(promise);
    // this.carrier = server;
    // this.carrier = Observable.concat(cache, server);
    // this.cache.updateCache('carriers' + this.queryString, this.carrier);

    return promise;
  }

  callGetCarrier(apigClient: any, carrierId: number): Promise<any> {
    this.logger.log('carriers.service', 'callGetCarrier', carrierId);
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          id: carrierId
        }
      };
      try {
        apigClient.carriersGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('carriers.service', 'carrier result', result);
            let carrier = new Carrier(result.data.items[0], this.app.accountType);
            this.seo.setCarrier(carrier);
            
            if (carrier.id == 0){
              this.noCarrier = true;
            }
            resolve(carrier);
          }).catch((err) => {
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        reject(null);
      }
    });
  }

  resizeSidebar() {
    setTimeout(() => {
      try {
        this.el = document.getElementById('refine-sidebar-inner');
        this.content = document.getElementById('results-content');
        this.container = document.getElementById('content-sidebar-wrapper');

        this.renderer.setElementProperty(this.container, 'style', false);

        if (this.el.scrollHeight > this.content.scrollHeight) {
          let heightNum = (this.el.scrollHeight + 200);
          this.renderer.setElementStyle(this.container, 'height', heightNum + 'px');
        }
      } catch (ex) {
      }
    }, 50);
  }


  getLocalContacts(carrierId: number, params: any): Promise<any> {
    this.logger.log('carriers.service', 'getCarriers', carrierId);
    // let cache = this.cache.get('carriers' + carrierId);
    let promise = this.api.getApiClient().then(client => this.callGetLocalContacts(client, carrierId, params));
    // let server = Observable.fromPromise(promise);
    // this.carrier = server;
    // this.carrier = Observable.concat(cache, server);
    // this.cache.updateCache('carriers' + this.queryString, this.carrier);

    return promise;
  }

  callGetLocalContacts(apigClient: any, carrierId: number, paramsToSend: any): Promise<any> {
    this.logger.log('carriers.service', 'callGetLocalContacts', carrierId);
    return new Promise((resolve, reject) => {
      let params = {
        carrierId: carrierId
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: paramsToSend
      };
      try {
        apigClient.carriersCarrierIdContactsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('carriers.service', 'contacts result', result);

            let contacts = new Contacts(result, this.app.accountType);
            resolve(contacts);
          }).catch((err) => {
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        reject(null);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/carriers/carriers.service.ts